var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"ecccd01b2c1afe36806af92b2d31f3e471e4166b"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["rock@rocket-resume"]={id:"ecccd01b2c1afe36806af92b2d31f3e471e4166b"};
      